export default __webpack_public_path__ + "static/gradient-right-36d7e7dfcb4b828ab71868b283d4d40d.png";